import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import { matchStatusTransformer } from '@/utils/matchStatusTransformer'

const Source = Axios.CancelToken.source()

import modules from './modules'

Vue.use(Vuex)
export default new Vuex.Store({
  modules,
  state: {
    pageTitle: 'dashboard',
    headerTabs: null,
    headerEditShow: false,
    inviteCount: 0,
    selectedGroup: 0,
    emailAvailability: null,
    usernameAvailability: null,
    matchStatus: '',
    hasMaxWidth: true,
    nextPage: '',
    prevPage: '',
    imageBackground: false,
    showBottomNav: true,
    showBackButton: false,
    showSelectButton: {
      show: false,
      label: ''
    },
    showCancelButton: false,
    showLogo: true
  },
  getters: {
    PAGE_TITLE: state => state.pageTitle,
    HEADER_TABS: state => state.headerTabs,
    HEADER_EDIT: state => state.headerEditShow,
    INVITE_COUNT: state => state.inviteCount,
    SELECTED_GROUP_INDEX: state => state.selectedGroup,
    EMAIL_AVAILABILITY_RESPONSE: state => state.emailAvailability,
    USERNAME_AVAILABILITY_RESPONSE: state => state.usernameAvailability,
    MATCH_STATUS_AVAILABILITY: state => state.matchStatus,
    HAS_MAX_WIDTH: state => state.hasMaxWidth,
    NEXT_PAGE: state => state.nextPage,
    PREV_PAGE: state => state.prevPage,
    IMAGE_BACKGROUND: state => state.imageBackground,
    SHOW_BOTTOM_NAV: state => state.showBottomNav,
    SHOW_BACK_BUTTON: state => state.showBackButton,
    SHOW_SELECT_BUTTON: state => state.showSelectButton,
    SHOW_CANCEL_BUTTON: state => state.showCancelButton,
    SHOW_LOGO: state => state.showLogo
  },
  mutations: {
    SET_PAGE_TITLE: (state, payload) => {
      state.pageTitle = payload
    },
    SET_HEADER_TABS: (state, payload) => {
      state.headerTabs = payload
    },
    SET_HEADER_EDIT_VISITBILITY: (state, payload) => {
      state.headerEditShow = payload
    },
    SET_INVITE_COUNT: (state, payload) => {
      state.inviteCount = payload
    },
    SET_SELECTED_GROUP_INDEX: (state, payload) => {
      state.selectedGroup = payload
    },
    SET_EMAIL_AVAILABILITY_RESPONSE: (state, payload) => {
      state.emailAvailability = payload
    },
    SET_USERNAME_AVAILABILITY_RESPONSE: (state, payload) => {
      state.usernameAvailability = payload
    },
    SET_MATCH_STATUS_AVAILABILITY: (state, payload) => {
      state.matchStatus = payload
    },
    SET_HAS_MAX_WIDTH: (state, payload) => {
      state.hasMaxWidth = payload
    },
    SET_NEXT_PAGE: (state, payload) => {
      state.nextPage = payload
    },
    SET_PREV_PAGE: (state, payload) => {
      state.prevPage = payload
    },
    SET_IMAGE_BACKGROUND: (state, payload) => {
      state.imageBackground = payload
    },
    SET_SHOW_BOTTOM_NAV: (state, payload) => {
      state.showBottomNav = payload
    },
    SET_SHOW_BACK_BUTTON: (state, payload) => {
      state.showBackButton = payload
    },
    SET_SHOW_SELECT_BUTTON: (state, payload) => {
      state.showSelectButton = payload
    },
    SET_SHOW_CANCEL_BUTTON: (state, payload) => {
      state.showCancelButton = payload
    },
    SET_SHOW_LOGO: (state, payload) => {
      state.showLogo = payload
    }
  },
  actions: {
    FETCH_INVITE_COUNT: async context => {
      try {
        const response = await Axios.get('/group/invite/count')
        context.commit('SET_INVITE_COUNT', response.data.data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error: ${error.response.data}`)
      }
    },
    CHECK_EMAIL_AVAILABILITY: async (context, payload) => {
      try {
        const response = await Axios.post('/user/check-email', payload)
        context.commit('SET_EMAIL_AVAILABILITY_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_EMAIL_AVAILABILITY_RESPONSE', error.response.data)
      }
    },
    CHECK_USERNAME_AVAILABILITY: async (context, payload) => {
      try {
        const response = await Axios.post('/user/check-username', payload)
        context.commit('SET_USERNAME_AVAILABILITY_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_USERNAME_AVAILABILITY_RESPONSE',
          error.response.data
        )
      }
    },
    CANCEL_AJAX_REQUEST: () => {
      Source.cancel()
    },
    TRANSORM_MATCH_STATUS: (context, payload) => {
      context.commit(
        'SET_MATCH_STATUS_AVAILABILITY',
        matchStatusTransformer(payload)
      )
    },
    TOGGLE_HAS_MAX_WIDTH: (context, payload) => {
      context.commit('SET_HAS_MAX_WIDTH', payload)
    }
  }
})
